import React from "react";
import Navbar from "../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import "./noticia.css";
import Noticiacard from "../components/noticias/Noticiacard";
import Tickertape from "../components/tradingview/Tickertape";
import NoticiacardAngola from "../components/noticias/NoticiacardAngola";
import { CircularProgress } from "@material-ui/core";

export default function Noticias() {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  var merge = [];
  const [news, setNews] = useState([]);
  const [newsNacional, setNewsNacional] = useState([]);
  const [newstitle, setNewstitle] = useState(false);
  const [newsinfo, setnewsinfo] = useState([]);
  const [newsdetails, setNewsdetails] = useState([]);

  useEffect(() => {
    const googlenews = async () => {
      const res = await axios.get("noticia/googleapi");
      setNews(res.data.articles);
    };
    googlenews();
  }, []);

  const newsAngolaEcomic = async () => {
    const res = await axios.get("scraper/jornaleconomia");
    for (let index = 0; index < res.data.length; index++) {
      merge.push(res.data[index]);
    }
  };

  const newsAngolaMercado = async () => {
    const res = await axios.get("scraper/jornalnegocios");
    for (let index = 0; index < res.data.length; index++) {
      merge.push(res.data[index]);
    }
  };

  const newsAngola = async () => {
    const res = await axios.get("scraper/jornaldeangola");
    for (let index = 0; index < res.data.length; index++) {
      merge.push(res.data[index]);
    }
    merge.sort((p1, p2) => {
      return new Date(p2.data) - new Date(p1.data);
    });
  };

  const getNewsinfo = async (fonte, link) => {
    try {
      const res = await axios.post("scraper/newsinfo", {
        fonte: fonte,
        url:
          fonte === "Mercado"
            ? "https://mercado.co.ao/" + link
            : "https://www.jornaldeangola.ao" + link,
      });
      setnewsinfo(res.data);
      console.log(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const newsAngolaGET = async () => {
      setNewsNacional(merge ? merge : []);
    };
    newsAngolaGET();
    newsAngolaEcomic();
    newsAngolaMercado();
    newsAngola();
  }, []);

  return (
    <div className="noticias">
      <div
        id="fill-dark-modal"
        className="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="fill-dark-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered modal-lg">
          <div className="modal-content modal-filled ">
            <div className="modal-header">
              <h1>{newsinfo.title}</h1>
            </div>
            <div className="modal-body">
              <p>
                {newsinfo.desc ? (
                  newsinfo.desc
                ) : (
                  <div className="text-center">
                    <CircularProgress color="green" size="200px" />
                  </div>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "10px" }}>
          <Tickertape />
        </div>
      </div>

      <div className="row" style={{ marginTop: "10px" }}>
        <div className={`${newstitle ? "inactive" : "col-md-4 scroll"} `}>
          <h4 className="text-center newstitle">Mantem-se Informado</h4>

          <div data-simplebar>
            <div className=" container card ribbon-box">
              <div className="card-body">
                <div className="ribbon ribbon-success float-end">
                  <i className="mdi mdi-access-point me-1"></i> Novo
                </div>
                <h5 className=" float-start mt-0">EMAINVEST-SCVM</h5>
                <div className="ribbon-content">
                  EMAINVEST-SCVM vem por esse meio para informa que a sala de
                  negociação estara aberta a partir da manha!
                  <br />
                  estamos ansioso para conhecer os novos investidores boa sorte
                  para todos. e um bom dia.
                </div>
              </div>
            </div>

            <div className="card cta-box bg-danger text-white">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="w-100 overflow-hidden">
                    <h2 className="mt-0">
                      <i className="mdi mdi-bullhorn-outline"></i>
                    </h2>
                    <h3 className="m-0 fw-normal cta-box-title">
                      Alcança o publico <b>Desejada!</b> faça sua publicdades
                      aqui!
                      <i className="mdi mdi-arrow-right-bold-outline"></i>
                    </h3>
                  </div>
                  <img
                    className="ms-3"
                    src="assets/images/email-campaign.svg"
                    width="120"
                    alt="Generic placeholder image"
                  />
                </div>
              </div>
            </div>

            <div
              id="carouselExampleCaption"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner" role="listbox">
                <div className="carousel-item active">
                  <img
                    src="assets/images/noticias/pexels-cottonbro-4430320.jpg"
                    alt="..."
                    className="d-block img-fluid col-12"
                  />
                  <div className="carousel-caption d-none d-md-block">
                    <h3 className="text-white">EmaInvest</h3>
                    <p style={{ fontWeight: "bold" }}>
                      Pensa no <span className="text-warning">FUTURO</span> da
                      sua famila
                    </p>
                  </div>
                </div>
                <div className="carousel-item">
                  <img
                    src="assets/images/noticias/pexels-christina-morillo-1181352.jpg"
                    alt="..."
                    className="d-block img-fluid col-12"
                  />
                  <div className="carousel-caption d-none d-md-block">
                    <h3 className="text-white">Ja Começaste a Investir?</h3>
                    <p style={{ fontWeight: "bold" }}>
                      Não perca Tempo investe
                      <span className="text-primary"> com EMAINVEST</span>
                    </p>
                  </div>
                </div>
                <div className="carousel-item">
                  <img
                    src="assets/images/noticias/family.jpg"
                    alt="..."
                    className="d-block img-fluid col-12"
                  />
                  <div className="carousel-caption d-none d-md-block">
                    <h3 className="text-black">EmaInvest</h3>
                    <p style={{ fontWeight: "bold" }}>
                      Torna seus Sonhos em REALIDADE!
                    </p>
                  </div>
                </div>
              </div>
              <a
                className="carousel-control-prev"
                href="#carouselExampleCaption"
                role="button"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </a>
              <a
                className="carousel-control-next"
                href="#carouselExampleCaption"
                role="button"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </a>
            </div>
          </div>
        </div>

        <div className={`${newstitle ? "inactive" : "col-md-4 scroll "}  `}>
          <h4 className="text-center newstitle">
            Noticías Sobre Económia Mundial
          </h4>
          <div className="row">
            <div className="newsarticle">
              {news.map((n) => (
                <Noticiacard noticias={n} />
              ))}
            </div>
          </div>
        </div>

        <div
          className={`${newstitle ? "col-md-12 scroll" : "col-md-4 scroll "} `}
        >
          <h4
            onClick={() => setNewstitle(!newstitle)}
            className="text-center newstitle"
          >
            Angola Live
          </h4>

          <div className="row">
            {newsNacional.map((n) => (
              <div
                className={`${newstitle ? "col-md-4" : ""} `}
                onClick={() => getNewsinfo(n.fonte, n.link)}
              >
                <NoticiacardAngola key={n.index} noticias={n} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
